<div class="ficheros-subidos" [class.ficheros-subidos--vertical]="orientacion === 'vertical'" [class.ficheros-subidos--solo-lectura]="soloLectura">
  <header class="ficheros-subidos__header">
    <h2 class="ficheros-subidos__title">{{ titulo }}</h2>
  </header>

  <div class="ficheros-subidos__body">
    <ng-container *ngIf="documentos.length; else emptyState">
      <div
        *ngIf="!soloLectura"
        class="ficheros-subidos__list"
        [class.ficheros-subidos__list--vertical]="orientacion === 'vertical'"
        cdkDropList
        [cdkDropListOrientation]="orientacion"
        [cdkDropListData]="documentos"
        (cdkDropListDropped)="reordenar($event)">
        <article
          class="ficheros-subidos__card"
          [class.is-active]="seleccionable && documento.id === documentoActivoId"
          [class.is-seleccionable]="seleccionable"
          *ngFor="let documento of documentos; trackBy: trackById"
          cdkDrag
          (click)="seleccionarDocumento(documento.id)">
          <ng-container *ngTemplateOutlet="tarjetaDocumento; context: { $implicit: documento }"></ng-container>
        </article>
      </div>

      <div
        *ngIf="soloLectura"
        class="ficheros-subidos__list"
        [class.ficheros-subidos__list--vertical]="orientacion === 'vertical'">
        <article
          class="ficheros-subidos__card"
          *ngFor="let documento of documentos; trackBy: trackById">
          <ng-container *ngTemplateOutlet="tarjetaDocumento; context: { $implicit: documento }"></ng-container>
        </article>
      </div>
    </ng-container>

    <ng-template #tarjetaDocumento let-documento>
      <div class="ficheros-subidos__card-toolbar" *ngIf="!soloLectura">
        <button class="ficheros-subidos__close" type="button" (click)="$event.stopPropagation(); eliminarDocumento(documento.id)">x</button>
      </div>

      <div class="ficheros-subidos__thumb">
        <div class="ficheros-subidos__thumb-frame" *ngIf="documento.miniatura; else iconoDocumento">
          <img [src]="documento.miniatura" [alt]="documento.nombre">
        </div>
        <ng-template #iconoDocumento>
          <svg><use xlink:href="#hs-doc"></use></svg>
        </ng-template>
      </div>

      <div
        class="ficheros-subidos__name"
        [matTooltip]="documento.nombre"
        matTooltipClass="ficheros-subidos__tooltip"
        matTooltipPosition="above">{{ documento.nombre }}</div>
    </ng-template>

    <ng-template #emptyState>
      <p class="ficheros-subidos__empty">Aun no has anadido documentos.</p>
    </ng-template>
  </div>
</div>
